import { useState } from 'react';
import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { LayoutDashboard, Users, Wallet, FileText, LogOut, X, Menu } from 'lucide-react';
import { useAuth } from '@/features/auth/hooks/useAuth';
import '../company.css';

export default function CompanyLayout() {
    const [isOpen, setIsOpen] = useState(false);
    const { user, logout } = useAuth();
    const navigate = useNavigate();

    const handleLogout = () => {
        if(logout) logout();
        navigate('/login');
    };

    const navItems = [
        { to: '/company/dashboard', label: 'داشبورد', icon: LayoutDashboard, end: true },
        { to: '/company/employees', label: 'مدیریت پرسنل', icon: Users },
        { to: '/company/wallet', label: 'کیف پول و اعتبار', icon: Wallet },
        { to: '/company/contracts', label: 'قراردادهای خرید پرسنل', icon: FileText },
    ];

    return (
        <div className="company-panel-layout">
            {isOpen && (
                <div className="company-sidebar-overlay" onClick={() => setIsOpen(false)} />
            )}

            <aside className={`company-sidebar glass-sidebar ${isOpen ? 'open' : ''}`}>
                {/* هدر سایدبار بدون عنوان (فقط دکمه بستن در موبایل) */}
                <div className="company-sidebar-header">
                    <button onClick={() => setIsOpen(false)} className="company-sidebar-close hidden-mobile" aria-label="بستن منو">
                        <X size={18} />
                    </button>
                </div>

                <nav className="company-nav">
                    {navItems.map((item) => {
                        const Icon = item.icon;
                        return (
                            <NavLink
                                key={item.to}
                                to={item.to}
                                end={item.end}
                                className={({ isActive }) => `company-nav-link ${isActive ? 'active' : ''}`}
                                title={item.label}
                                onClick={() => setIsOpen(false)}
                            >
                                <Icon size={20} className="nav-icon" />
                                <span>{item.label}</span>
                            </NavLink>
                        );
                    })}
                </nav>

                <div className="company-sidebar-footer">
                    <button onClick={handleLogout} className="company-logout-btn" title="خروج">
                        <LogOut size={20} className="nav-icon" />
                        <span>خروج</span>
                    </button>
                </div>
            </aside>

            <main className="company-main-content">
                {/* هدر مخصوص موبایل برای باز کردن منو */}
                <header className="company-mobile-header">
                    <button onClick={() => setIsOpen(true)} className="company-menu-btn" aria-label="باز کردن منو">
                        <Menu size={22} />
                    </button>
                    <span className="company-mobile-title">پنل شرکت</span>
                </header>

                <div className="company-page-content">
                    <Outlet />
                </div>
            </main>
        </div>
    );
}